import React from "react";
import HeroSection from "./HeroSection";
import getEnvEndpoints from "../../utils/endpoints";
import LogService from "../../utils/logs";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import {
  getAdobeAnalyticsEventObject,
  getAdobeAnalyticsCustomLinkObj


} from '../../analytics/analyticsObject';
const endpoints = getEnvEndpoints();
const HeroSectionUserPaid = ({ gotoPlans, spxPurchase, isMember }) => {
  const spxPurchaseUrl = endpoints.spxPurchaseUrl;
  const spxPurchaseClick = async () => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'subscribe',
      "landing-page",
      spxPurchaseUrl
    );

    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
    try {
      await LogService.logSpxPurchaseClick();

    } catch (e) { }
    window.location = spxPurchaseUrl;
  }

  return (
    <HeroSection
      title="PMIstandards+  Success at Your Fingertips"
      tagLine="Choose the plan that is right for you."
    >
      <div className="flex flex-col justify-center items-center px-8" adoberegion="landing-page">
        {spxPurchase && !isMember && (
          <button
            className={`bg-orange-brand-500 hover:bg-gray-900 rounded text-white py-4 px-4`}
            onClick={() => spxPurchaseClick()}
          >
            SUBSCRIBE
          </button>
        ) || (
            <button
              onClick={gotoPlans}
              className={`bg-orange-brand-500 hover:bg-gray-900 rounded text-white py-4 px-4`}
            >
              CHOOSE YOUR PLAN
            </button>
          )
        }
      </div>
    </HeroSection>
  );
};

export default HeroSectionUserPaid;
